import * as React from 'react'
import {
  IPage
} from '../types'
import * as Page from '../service/page'
import Result from './result'


export default class NameList extends React.Component<{
  base: string
  page: IPage
  onShowName: (name: string) => void
}> {

  render() {
    const {
      base,
      page,
      onShowName,
    } = this.props

    return (
      <div className="pages">

        <div className="results">
          {page.names.map(name =>
            <Result
              key={name}
              base={base}
              result={name}
              state={Page.getNameState(page, name)}
              onShow={onShowName}
            />
          )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comp/name-list.tsx